export default __webpack_public_path__ + "static/government-property-function-9220805dab64e1c1a98d666f26cbb0ad.png";